export default "__VITE_ASSET__92b56dbb__"